import { VideoSlice } from '../../prismicio-types'
import styles from './Video.module.css'
import { isFilled } from '@prismicio/client'

export class Video {
	static render(props: VideoSlice) {
		const {
			primary: { video }
		} = props

		return /* HTML */ `
			<div class="${styles.Main}">
				${isFilled.linkToMedia(video) ? `<video src="${video.url}" controls></video>` : ''}
			</div>
		`
	}
}
